(ns common.country
  (:require
   [clojure.string :as string]))

(def countries-meta
  {:AF {:translations {:en "Afghanistan"
                       :fi "Afganistan"}}
   :AL {:translations {:en "Albania"
                       :fi "Albania"}}
   :DZ {:translations {:en "Algeria"
                       :fi "Algeria"}}
   :AS {:translations {:en "American Samoa"
                       :fi "Amerikan Samoa"}}
   :AD {:translations {:en "Andorra"
                       :fi "Andorra"}}
   :AO {:translations {:en "Angola"
                       :fi "Angola"}}
   :AI {:translations {:en "Anguilla"
                       :fi "Anguilla"}}
   :AQ {:translations {:en "Antarctic"
                       :fi "Antarktis"}}
   :AG {:translations {:en "Antigua and Barbuda"
                       :fi "Antigua ja Barbuda"}}
   :AR {:translations {:en "Argentina"
                       :fi "Argentiina"}}
   :AM {:translations {:en "Armenia"
                       :fi "Armenia"}}
   :AW {:translations {:en "Aruba"
                       :fi "Aruba"}}
   :AU {:translations {:en "Australia"
                       :fi "Australia"}}
   :AT {:translations {:en "Austria"
                       :fi "Itävalta"}}
   :AZ {:translations {:en "Azerbaijan"
                       :fi "Azerbaidžan"}}
   :BS {:translations {:en "Bahamas"
                       :fi "Bahama"}}
   :BH {:translations {:en "Bahrain"
                       :fi "Bahrain"}}
   :BD {:translations {:en "Bangladesh"
                       :fi "Bangladesh"}}
   :BB {:translations {:en "Barbados"
                       :fi "Barbados"}}
   :BY {:translations {:en "Belarus"
                       :fi "Valko-Venäjä"}}
   :BE {:translations {:en "Belgium"
                       :fi "Belgia"}}
   :BZ {:translations {:en "Belize"
                       :fi "Belize"}}
   :BJ {:translations {:en "Benin"
                       :fi "Benin"}}
   :BM {:translations {:en "Bermuda"
                       :fi "Bermuda"}}
   :BT {:translations {:en "Bhutan"
                       :fi "Bhutan"}}
   :BO {:translations {:en "Bolivia"
                       :fi "Bolivia"}}
   :BQ {:translations {:en "Bonaire, Sint Eustatius and Saba"
                       :fi "Bonaire, Sint Eustatius ja Saba"}}
   :BA {:translations {:en "Bosnia and Herzegovina"
                       :fi "Bosnia ja Hertsegovina"}}
   :BW {:translations {:en "Botswana"
                       :fi "Botswana"}}
   :BV {:translations {:en "Bouvet Island"
                       :fi "Bouvet'nsaari"}}
   :BR {:translations {:en "Brazil"
                       :fi "Brasilia"}}
   :IO {:translations {:en "British Indian Ocean Territory"
                       :fi "Brittiläinen Intian valtameren alue"}}
   :BN {:translations {:en "Brunei"
                       :fi "Brunei"}}
   :BG {:translations {:en "Bulgaria"
                       :fi "Bulgaria"}}
   :BF {:translations {:en "Burkina Faso"
                       :fi "Burkina Faso"}}
   :BI {:translations {:en "Burundi"
                       :fi "Burundi"}}
   :KH {:translations {:en "Cambodia"
                       :fi "Kambodža"}}
   :CM {:translations {:en "Cameroon"
                       :fi "Kamerun"}}
   :CA {:translations {:en "Canada"
                       :fi "Kanada"}}
   :CV {:translations {:en "Cabo Verde"
                       :fi "Kap Verde"}}
   :KY {:translations {:en "Cayman Islands"
                       :fi "Caymansaaret"}}
   :CF {:translations {:en "Central African Republic"
                       :fi "Keski-Afrikan tasavalta"}}
   :TD {:translations {:en "Chad"
                       :fi "Tšad"}}
   :CL {:translations {:en "Chile"
                       :fi "Chile"}}
   :CN {:translations {:en "China"
                       :fi "Kiina"}}
   :CX {:translations {:en "Christmas Island"
                       :fi "Joulusaari"}}
   :CC {:translations {:en "Cocos (Keeling) Islands"
                       :fi "Kookossaaret"}}
   :CO {:translations {:en "Colombia"
                       :fi "Kolumbia"}}
   :KM {:translations {:en "Comoros"
                       :fi "Komorit"}}
   :CG {:translations {:en "Congo"
                       :fi "Kongo"}}
   :CD {:translations {:en "Congo, The Democratic Republic of the"
                       :fi "Kongon demokraattinen tasavalta"}}
   :CK {:translations {:en "Cook Islands"
                       :fi "Cookinsaaret"}}
   :CR {:translations {:en "Costa Rica"
                       :fi "Costa Rica"}}
   :HR {:translations {:en "Croatia"
                       :fi "Kroatia"}}
   :CU {:translations {:en "Cuba"
                       :fi "Kuuba"}}
   :CW {:translations {:en "Curaçao"
                       :fi "Curaçao"}}
   :CY {:translations {:en "Cyprus"
                       :fi "Curaçao"}}
   :CZ {:translations {:en "Czechia"
                       :fi "Tšekki"}}
   :CI {:translations {:en "Côte d'Ivoire"
                       :fi "Norsunluurannikko"}}
   :DK {:translations {:en "Denmark"
                       :fi "Tanska"}}
   :DJ {:translations {:en "Djibouti"
                       :fi "Djibouti"}}
   :DM {:translations {:en "Dominica"
                       :fi "Dominica"}}
   :DO {:translations {:en "Dominican Republic, The"
                       :fi "Dominikaaninen tasavalta"}}
   :EC {:translations {:en "Ecuador"
                       :fi "Ecuador"}}
   :EG {:translations {:en "Egypt"
                       :fi "Egypti"}}
   :SV {:translations {:en "El Salvador"
                       :fi "El Salvador"}}
   :GQ {:translations {:en "Equatorial Guinea"
                       :fi "Päiväntasaajan Guinea"}}
   :ER {:translations {:en "Eritrea"
                       :fi "Eritrea"}}
   :EE {:translations {:en "Estonia"
                       :fi "Viro"}}
   :ET {:translations {:en "Ethiopia"
                       :fi "Etiopia"}}
   :FK {:translations {:en "Falkland Islands (Malvinas)"
                       :fi "Falklandinsaaret"}}
   :FO {:translations {:en "Faroe Islands"
                       :fi "Färsaaret"}}
   :FJ {:translations {:en "Fiji"
                       :fi "Fidži"}}
   :FI {:translations {:en "Finland"
                       :fi "Suomi"}}
   :FR {:translations {:en "France"
                       :fi "Ranska"}}
   :GF {:translations {:en "French Guiana"
                       :fi "Ranskan Guayana"}}
   :PF {:translations {:en "French Polynesia"
                       :fi "Ranskan Polynesia"}}
   :TF {:translations {:en "French Southern Territories"
                       :fi "Ranskan eteläiset alueet"}}
   :GA {:translations {:en "Gabon"
                       :fi "Gabon"}}
   :GM {:translations {:en "Gambia"
                       :fi "Gambia"}}
   :GE {:translations {:en "Georgia"
                       :fi "Georgia"}}
   :DE {:translations {:en "Germany"
                       :fi "Saksa"}}
   :GH {:translations {:en "Ghana"
                       :fi "Ghana"}}
   :GI {:translations {:en "Gibraltar"
                       :fi "Gibraltar"}}
   :GR {:translations {:en "Greece"
                       :fi "Kreikka"}}
   :GL {:translations {:en "Greenland"
                       :fi "Grönlanti"}}
   :GD {:translations {:en "Grenada"
                       :fi "Grenada"}}
   :GP {:translations {:en "Guadeloupe"
                       :fi "Guadeloupe"}}
   :GU {:translations {:en "Guam"
                       :fi "Guam"}}
   :GT {:translations {:en "Guatemala"
                       :fi "Guatemala"}}
   :GG {:translations {:en "Guernsey"
                       :fi "Guernsey"}}
   :GN {:translations {:en "Guinea"
                       :fi "Guinea"}}
   :GW {:translations {:en "Guinea-Bissau"
                       :fi "Guinea-Bissau"}}
   :GY {:translations {:en "Guyana"
                       :fi "Guyana"}}
   :HT {:translations {:en "Haiti"
                       :fi "Haiti"}}
   :HM {:translations {:en "Heard Island and McDonald Islands"
                       :fi "Heard ja McDonaldinsaaret"}}
   :HN {:translations {:en "Honduras"
                       :fi "Honduras"}}
   :HK {:translations {:en "Hong Kong"
                       :fi "Hong Kong"}}
   :HU {:translations {:en "Hungary"
                       :fi "Unkari"}}
   :IS {:translations {:en "Iceland"
                       :fi "Islanti"}}
   :IN {:translations {:en "India"
                       :fi "Intia"}}
   :ID {:translations {:en "Indonesia"
                       :fi "Indonesia"}}
   :IR {:translations {:en "Iran, The Islamic Republic of"
                       :fi "Iran"}
        :alternate-translations {:en ["Iran"]
                                 :fi ["Iran"]}}
   :IQ {:translations {:en "Iraq"
                       :fi "Irak"}}
   :IE {:translations {:en "Ireland"
                       :fi "Irlanti"}}
   :IM {:translations {:en "Isle of Man"
                       :fi "Mansaari"}}
   :IL {:translations {:en "Israel"
                       :fi "Israel"}}
   :IT {:translations {:en "Italy"
                       :fi "Italia"}}
   :JM {:translations {:en "Jamaica"
                       :fi "Jamaica"}}
   :JP {:translations {:en "Japan"
                       :fi "Japani"}}
   :JE {:translations {:en "Jersey"
                       :fi "Jersey"}}
   :JO {:translations {:en "Jordan"
                       :fi "Jordania"}}
   :KZ {:translations {:en "Kazakhstan"
                       :fi "Kazakhstan"}}
   :KE {:translations {:en "Kenya"
                       :fi "Kenia"}}
   :KI {:translations {:en "Kiribati"
                       :fi "Kiribati"}}
   :KP {:translations {:en "Korea, The Democratic People's Republic of"
                       :fi "Pohjois Korea"}
        :alternate-translations {:en ["North Korea"]
                                 :fi ["Pohjois-Korea"]}}
   :KR {:translations {:en "Korea, Republic of"
                       :fi "Etelä-Korea"}
        :alternate-translations {:en ["South Korea"]
                                 :fi ["Etelä Korea"]}}
   :KW {:translations {:en "Kuwait"
                       :fi "Kuwait"}}
   :KG {:translations {:en "Kyrgyzstan"
                       :fi "Kirgistan"}}
   :LA {:translations {:en "Lao People's Democratic Republic"
                       :fi "Laos"}}
   :LV {:translations {:en "Latvia"
                       :fi "Latvia"}}
   :LB {:translations {:en "Lebanon"
                       :fi "Libanon"}}
   :LS {:translations {:en "Lesotho"
                       :fi "Lesoto"}}
   :LR {:translations {:en "Liberia"
                       :fi "Liberia"}}
   :LY {:translations {:en "Libya"
                       :fi "Libya"}}
   :LI {:translations {:en "Liechtenstein"
                       :fi "Liechtenstein"}}
   :LT {:translations {:en "Lithuania"
                       :fi "Liettua"}}
   :LU {:translations {:en "Luxembourg"
                       :fi "Luxembourg"}}
   :MO {:translations {:en "Macao"
                       :fi "Macao"}}
   :MG {:translations {:en "Madagascar"
                       :fi "Madagascar"}}
   :MW {:translations {:en "Malawi"
                       :fi "Malawi"}}
   :MY {:translations {:en "Malaysia"
                       :fi "Malesia"}}
   :MV {:translations {:en "Maldives"
                       :fi "Malediivit"}}
   :ML {:translations {:en "Mali"
                       :fi "Mali"}}
   :MT {:translations {:en "Malta"
                       :fi "Malta"}}
   :MH {:translations {:en "Marshall Islands"
                       :fi "Marshallin saaret"}}
   :MQ {:translations {:en "Martinique"
                       :fi "Martinique"}}
   :MR {:translations {:en "Mauritania"
                       :fi "Mauritania"}}
   :MU {:translations {:en "Mauritius"
                       :fi "Mauritius"}}
   :YT {:translations {:en "Mayotte"
                       :fi "Mayotte"}}
   :MX {:translations {:en "Mexico"
                       :fi "Meksiko"}}
   :FM {:translations {:en "Micronesia, Federated States of"
                       :fi "Microneesia"}}
   :MD {:translations {:en "Moldova, Republic of"
                       :fi "Moldova"}}
   :MC {:translations {:en "Monaco"
                       :fi "Monaco"}}
   :MN {:translations {:en "Mongolia"
                       :fi "Mongolia"}}
   :ME {:translations {:en "Montenegro"
                       :fi "Montenegro"}}
   :MS {:translations {:en "Montserrat"
                       :fi "Montserrat"}}
   :MA {:translations {:en "Morocco"
                       :fi "Marokko"}}
   :MZ {:translations {:en "Mozambique"
                       :fi "Mozambik"}}
   :MM {:translations {:en "Myanmar"
                       :fi "Myanmar"}}
   :NA {:translations {:en "Namibia"
                       :fi "Namibia"}}
   :NR {:translations {:en "Nauru"
                       :fi "Nauru"}}
   :NP {:translations {:en "Nepal"
                       :fi "Nepal"}}
   :NL {:translations {:en "Netherlands"
                       :fi "Alankomaat"}}
   :NC {:translations {:en "New Caledonia"
                       :fi "Uusi Kaledonia"}}
   :NZ {:translations {:en "New Zealand"
                       :fi "Uusi Seelanti"}}
   :NI {:translations {:en "Nicaragua"
                       :fi "Nicaragua"}}
   :NE {:translations {:en "Niger"
                       :fi "Niger"}}
   :NG {:translations {:en "Nigeria"
                       :fi "Nigeria"}}
   :NU {:translations {:en "Niue"
                       :fi "Niue"}}
   :NF {:translations {:en "Norfolk Island"
                       :fi "Norfolkin saaret"}}
   :MK {:translations {:en "North Macedonia"
                       :fi "Phojois Makedonia"}}
   :MP {:translations {:en "Northern Mariana Islands"
                       :fi "Pohjois-Mariaanit"}}
   :NO {:translations {:en "Norway"
                       :fi "Norja"}}
   :OM {:translations {:en "Oman"
                       :fi "Oman"}}
   :PK {:translations {:en "Pakistan"
                       :fi "Pakistan"}}
   :PW {:translations {:en "Palau"
                       :fi "Palau"}}
   :PA {:translations {:en "Panama"
                       :fi "Panama"}}
   :PG {:translations {:en "Papua New Guinea"
                       :fi "Papua Uusi Guinea"}}
   :PY {:translations {:en "Paraguay"
                       :fi "Paraguay"}}
   :PE {:translations {:en "Peru"
                       :fi "Peru"}}
   :PH {:translations {:en "Philippines"
                       :fi "Philippiinit"}}
   :PN {:translations {:en "Pitcairn"
                       :fi "Pitcairn"}}
   :PL {:translations {:en "Poland"
                       :fi "Puola"}}
   :PT {:translations {:en "Portugal"
                       :fi "Portugali"}}
   :PR {:translations {:en "Puerto Rico"
                       :fi "Puerto Rico"}}
   :QA {:translations {:en "Qatar"
                       :fi "Qatar"}}
   :RO {:translations {:en "Romania"
                       :fi "Romania"}}
   :RU {:translations {:en "Russian Federation"
                       :fi "Venäjä"}
        :alternate-translations {:en ["Russia"]
                                 :fi ["Russia"]}}
   :RW {:translations {:en "Rwanda"
                       :fi "Ruanda"}}
   :RE {:translations {:en "Réunion"
                       :fi "Reunion"}}
   :BL {:translations {:en "Saint Barthélemy"
                       :fi "Saint-Barthélemy"}}
   :SH {:translations {:en "Saint Helena, Ascension and Tristan da Cunha"
                       :fi "Saint Helena"}}
   :KN {:translations {:en "Saint Kitts and Nevis"
                       :fi "Saint Kitts ja Nevis"}}
   :LC {:translations {:en "Saint Lucia"
                       :fi "Saint Lucia"}}
   :MF {:translations {:en "Saint Martin (French Part)"
                       :fi "Saint Martin"}}
   :PM {:translations {:en "Saint Pierre and Miquelon"
                       :fi "Saint Pierre ja Miquelon"}}
   :VC {:translations {:en "Saint Vincent and the Grenadines"
                       :fi "Saint Vincent ja Grenadiinit"}}
   :WS {:translations {:en "Samoa"
                       :fi "Samoa"}}
   :SM {:translations {:en "San Marino"
                       :fi "San Marino"}}
   :ST {:translations {:en "Sao Tome and Principe"
                       :fi "São Tomé ja Príncipe"}}
   :SA {:translations {:en "Saudi Arabia"
                       :fi "Saudi Arabia"}}
   :SN {:translations {:en "Senegal"
                       :fi "Senegal"}}
   :RS {:translations {:en "Serbia"
                       :fi "Servia"}}
   :SC {:translations {:en "Seychelles"
                       :fi "Seychelles"}}
   :SL {:translations {:en "Sierra Leone"
                       :fi "Sierra Leone"}}
   :SG {:translations {:en "Singapore"
                       :fi "Singapore"}}
   :SX {:translations {:en "Sint Maarten (Dutch Part)"
                       :fi "Sint Maarten"}}
   :SK {:translations {:en "Slovakia"
                       :fi "Slovakia"}}
   :SI {:translations {:en "Slovenia"
                       :fi "Slovenia"}}
   :SB {:translations {:en "Solomon Islands"
                       :fi "Salomonin saaret"}}
   :SO {:translations {:en "Somalia"
                       :fi "Somalia"}}
   :ZA {:translations {:en "South Africa"
                       :fi "Etelä Afrikka"}}
   :GS {:translations {:en "South Georgia and the South Sandwich Islands"
                       :fi "Etelä-Georgia ja Eteläiset Sandwichsaaret"}}
   :SS {:translations {:en "South Sudan"
                       :fi "Etelä Sudan"}}
   :ES {:translations {:en "Spain"
                       :fi "Espanja"}}
   :LK {:translations {:en "Sri Lanka"
                       :fi "Sri Lanka"}}
   :SD {:translations {:en "Sudan"
                       :fi "Sudan"}}
   :SR {:translations {:en "Suriname"
                       :fi "Surinam"}}
   :SJ {:translations {:en "Svalbard and Jan Mayen"
                       :fi "Huippuvuoret"}}
   :SZ {:translations {:en "Eswatini"
                       :fi "Eswatini"}}
   :SE {:translations {:en "Sweden"
                       :fi "Ruotsi"}}
   :CH {:translations {:en "Switzerland"
                       :fi "Sveitsi"}}
   :SY {:translations {:en "Syrian Arab Republic"
                       :fi "Syyria"}}
   :TW {:translations {:en "Taiwan"
                       :fi "Taiwan"}}
   :TJ {:translations {:en "Tajikistan"
                       :fi "Tadjikistan"}}
   :TZ {:translations {:en "Tanzania, United Republic of"
                       :fi "Tansania"}}
   :TH {:translations {:en "Thailand"
                       :fi "Thaimaa"}}
   :TL {:translations {:en "Timor-Leste"
                       :fi "Timor"}}
   :TG {:translations {:en "Togo"
                       :fi "Togo"}}
   :TK {:translations {:en "Tokelau"
                       :fi "Tokelau"}}
   :TO {:translations {:en "Tonga"
                       :fi "Tonga"}}
   :TT {:translations {:en "Trinidad and Tobago"
                       :fi "Trinidad ja Tobago"}}
   :TN {:translations {:en "Tunisia"
                       :fi "Tunisia"}}
   :TR {:translations {:en "Turkey"
                       :fi "Turkki"}}
   :TM {:translations {:en "Turkmenistan"
                       :fi "Turkmenistan"}}
   :TC {:translations {:en "Turks and Caicos Islands"
                       :fi "Turks- ja Caicossaaret "}}
   :TV {:translations {:en "Tuvalu"
                       :fi "Tuvalu"}}
   :UG {:translations {:en "Uganda"
                       :fi "Uganda"}}
   :UA {:translations {:en "Ukraine"
                       :fi "Ukraina"}}
   :AE {:translations {:en "United Arab Emirates"
                       :fi "Yhdistyneet Arabi Emiraatiit"}}
   :GB {:translations {:en "United Kingdom"
                       :fi "Iso-Britannia"}}
   :US {:translations {:en "United States"
                       :fi "Yhdysvallat"}
        :alternate-translations {:en ["USA"]
                                 :fi ["USA"]}}
   :UM {:translations {:en "United States Minor Outlying Islands"
                       :fi "Yhdysvaltain pienet erillissaaret"}}
   :UY {:translations {:en "Uruguay"
                       :fi "Uruguay"}}
   :UZ {:translations {:en "Uzbekistan"
                       :fi "Uzbekistan"}}
   :VU {:translations {:en "Vanuatu"
                       :fi "Vanuatu"}}
   :VE {:translations {:en "Venezuela, Bolivarian Republic of"
                       :fi "Venezuela"}}
   :VN {:translations {:en "Vietnam"
                       :fi "Vietnam"}}
   :VG {:translations {:en "Virgin Islands, British"
                       :fi "Brittiläiset Neitsytsaaret"}}
   :VI {:translations {:en "Virgin Islands, U.S."
                       :fi "Yhdysvaltain Neitsytsaaret"}}
   :WF {:translations {:en "Wallis and Futuna"
                       :fi "Wallis ja Futuna"}}
   :EH {:translations {:en "Western Sahara"
                       :fi "Länsi-Sahara"}}
   :YE {:translations {:en "Yemen"
                       :fi "Jemen"}}
   :ZM {:translations {:en "Zambia"
                       :fi "Sambia"}}
   :ZW {:translations {:en "Zimbabwe"
                       :fi "Zimbabwe"}}
   :AX {:translations {:en "Åland Islands"
                       :fi "Ahvenanmaa"}}})

(def options
  (->> countries-meta
       (map (fn [[c country-meta]]
              {:key          (name c)
               :keyword      c
               :value        c
               :translations (:translations country-meta)
               :label        (->> country-meta
                                  :translations
                                  :en)}))
       (sort-by :label)
       (vec)))

(defn localized-options
  [lang-kw]
  (->> options
       (map (fn [o]
              (merge (select-keys o [:key :keyword :label])
                     (when-let [lang-label (some-> o
                                                   :translations
                                                   (get lang-kw))]
                       {:label lang-label}))))
       (sort-by :label)
       (vec)))

(defn get-label
  ([cc]
   (get-label cc :en))
  ([cc lang-kw]
   (when (keyword? cc)
     (let [meta (get countries-meta cc)]
       (or (some-> meta
                   :translations
                   (get lang-kw))
           (some-> meta
                   :alternate-translations
                   (get lang-kw))
           (some-> meta
                   :translations
                   :en))))))

(def reverse-lookup-
  (->> countries-meta
       (mapcat (fn [[c metadata]]
                 (concat (->> metadata
                              :translations
                              (map (fn [[_lang translation]]
                                     [(string/lower-case translation) c])))
                         (->> metadata
                              :alternate-translations
                              (mapcat (fn [[_lang translations]]
                                        (->> translations
                                             (map (fn [translation]
                                                    [(string/lower-case translation) c])))))))))
       (into {})))

(defn resolve-from-name
  [country-name]
  (when country-name
    (get reverse-lookup- (string/lower-case country-name))))

(defn code-str->kw
  [code-str]
  (let [kw (keyword code-str)]
    (if (get countries-meta kw)
      kw
      (resolve-from-name code-str))))
